export default {
  tokeninvalidation: "token失效，请重新登录。",
  networkexception: "网络异常",
  systemloadminute: "系统负载1分钟",
  systemloadfiveminute: "系统负载5分钟",
  systemloadquarterminute: "系统负载15分钟",
  malfunction: "故障中",
  electricitylevel: "电量",
  charging: "充电中",
  cleanwatertank: "清水",
  bilgetank: "污水",
  positioningfailed: "定位失败",
  nothave: "无",
  positioningsuccessful: "定位成功",
  generalpositioning: "定位一般",
  imuinitialization: "IMU初始化中",
  laserinitialization: "激光初始化中",
  autonomousdriving: "自动驾驶",
  mapsloading: "地图加载中",
  datarequestfailed: "数据请求失败，请重试",
  CPUusagerate: "CPU使用率",
  physicalusagerate: "物理内存使用率",
  recordbag: "记录Bag",
  recording: "正在记录中",
  recorded: "记录成功",
  recordfailed: "记录失败，请重试",
  networkwrite: "网络写(KB/s)",
  networkread: "网络读(KB/s)",
  diskwrite: "磁盘写(KB/s)",
  diskread: "磁盘读(KB/s)",
  restart: "重启",
  speed: "车速",
  rollingbrushpressure: "滚刷压力",
  rollingbrushspeed: "滚刷转速",
  edgebrushspeed: "边刷转速",
  watercapacity: "喷水量",
  bibulouscrouching: "吸水扒",
  suctionlevel: "吸风等级",
  edgebrushpressure: "边刷压力",
  dustmop: "尘推",
  detergentconcentration: "清洁剂浓度",
  cleaningmode: "清洁模式",
  snap: "抓拍",
  snaping: "正在抓拍中",
  snaped: "图片抓拍成功",
  serialnumber: "序号",
  operate: "操作",
  view: "查看",
  intotal: "共",
  article: "条",
  capturetime: "抓拍时间",
  supplying: "补给中",
  autosupplying: "自动补给中",
  starttime: "开始时间",
  station: "工作站",
  supplymode: "补给模式",
  fullsupply: "全补给",
  chargeonly: "仅充电",
  initialization: "初始化",
  idle: "空闲",
  offline: "离线",
  dormancy: "休眠",
  crashstop: "急停",
  fault: "故障",
  mmode: "手动模式",
  duringcleaning: "清洁作业中",
  headingtodepot: "正在前往补给站",
  headingtodockingstations: "正在前往停靠点",
  remotecontrolready: "遥控就绪",
  remotecontroldriving: "遥控驾驶",
  manualintervention: "人工干预",
  shutdown: "关机中",
  forcedlabor: "强制人工",
  gotosupply: "前往补给",
  gotodock: "前往停靠",
  customize: "自定义模式",
  deepcleaning: "深度清洁",
  dailycleaning: "日常清洁",
  silentcleaning: "静音清洁",
  rewashingmode: "重洗模式",
  energysavingmode: "节能模式",
  dustpushmode: "尘推模式",
  manualdrive: "人工驾驶",
  automaticsupply: "自动补给",
  enable: "启用",
  disable: "禁用",
  vehiclerestartfailure: "车辆重启失败",
  determine: "确定",
  vehiclecannotrestart: "车辆无法重启",
  continuetorestart: "继续重启",
  thereareunfinishedtasks: "车端有尚未结束的任务， 重启后是否继续执行?",
  resumeafterrestart: "重启后继续",
  donotcontinueafterrestart: "重启后不继续",
  login: "登录",
  customermanagement: "场地管理",
  customerlist: "场地列表",
  newcustomer: "新建场地",
  userlist: "用户列表",
  newusers: "新增用户",
  vehiclelist: "车辆列表",
  relatedvehiclemanagement: "关联车辆管理",
  workstationmanagement: "工作站管理",
  usermanage: "用户管理",
  resourcestatistics: "资源统计",
  vehiclemanagement: "车辆管理",
  scheduledtasks: "定时任务",
  vehicleinformation: "车辆信息",
  operater: "运营",
  datastatistics: "数据统计",
  singlecardatastatistics: "单车数据统计",
  taskdetails: "任务详情",
  unattended: "无人值守",
  unattendedcontrol: "无人值守控制",
  set: "设置",
  securitysetting: "安全设置",
  pleaselogin: "请登录",
  combinedtasks: "组合任务",
  multifloortasks: "多楼层任务",
  notstarted: "未开始",
  underexecution: "执行中",
  completed: "已完成",
  abnormalend: "异常结束",
  paused: "暂停中",
  proactivelyending: "主动结束",
  edituser: "编辑用户",
  username: "用户名",
  inputusername: "请输入用户名",
  tel: "手机号",
  role: "角色",
  loginpassword: "登录密码",
  inputpassword: "请输入密码",
  confirmpassword: "确认密码",
  car: "车辆",
  cancellation: "取消",
  submit: "提交",
  enduser: "终端用户",
  repeataddvinhint: "车辆已经存在，请勿重复添加",
  passwordinputsinconsistent: "两次密码输入不一致",
  edited: "编辑成功",
  added: "添加成功",
  resetting: "重置中",
  vehiclestatus: "车辆状态",
  basicinformation: "基础信息",
  vehiclemodel: "车辆型号",
  vehiclearchitecture: "车辆架构",
  vehiclename: "车辆名称",
  modify: "修改",
  save: "保存",
  registrationtime: "注册时间",
  simcardiccid: "SIM卡ICCID",
  label: "标签",
  adminpassword: "admin密码",
  reset: "重置",
  userpassword: "user密码",
  versioninformation: "版本信息",
  softwareversion: "软件版本",
  hardwareversion: "硬件版本",
  resetsuccessful: "重置成功",
  timefiltering: "时间筛选",
  tasktype: "任务类型",
  statisticaldatadownload: "统计数据下载",
  yes: "是",
  deny: "否",
  details: "详情",
  whole: "全部",
  minute: "分钟",
  hour: "小时",
  taskname: "任务名称",
  cleaningfrequency: "清洁次数",
  taskstarttime: "任务开始时间",
  taskendtime: "任务结束时间",
  cleaningtime: "清洁时间",
  waterconsumption: "用水量",
  electricityconsumption: "用电量",
  plannedcleaningaream2: "计划清洁面积(㎡)",
  actualcleaningaream2: "实际清洁面积(㎡)",
  uncleanedaream2: "未清洁面积(㎡)",
  operator: "操作者",
  export: "导出",
  mapname: "地图名称",
  cleaningefficiencyh: "清洁效率",
  taskcompletionrate: "任务完成率",
  supplyfrequency: "补给次数",
  endtime: "结束时间",
  combinationtaskname: "组合任务名称",
  customername: "场地名称",
  onlineornot: "是否在线",
  online: "在线",
  notonline: "不在线",
  vehiclevin: "车辆VIN",
  customerphotos: "场地照片",
  uploadimages: "上传图片",
  workstationmode: "工作站模式",
  customeraddress: "场地地址",
  customerremarks: "场地备注",
  exclusivestake: "独享桩",
  sharedstake: "共享桩",
  offlinepile: "离线桩",
  customernamecannotbeemptyorblank: "场地名称不能为空或空格",
  customeraddresscannotbeemptyorblank: "场地地址不能为空或空格",
  thesizeoftheuploadedfilecannotexceed1mb: "上传文件大小不能超过1MB",
  theimagemustbeinjpgorpngformat: "图片必须是jpg或png格式",
  inputonly: "仅可输入",
  character: "位字符",
  pleaseentercustomernamevehiclevinworkstationzin:
    "请输入场地名称/车辆VIN/工作站ZIN",
  search: "搜索",
  workstationzin: "工作站ZIN",
  creationtime: "创建时间",
  founder: "创建人",
  supportvintagname: "支持VIN/标签名称搜索",
  time: "时间",
  rawdatadownload: "原始数据下载",
  customer: "场地",
  numberoftasks: "任务数",
  tasktimeconsumption: "任务耗时(min)",
  exitprompt: "退出提示",
  logout: "是否退出登录？",
  wxb: "蜗小白云端管理平台",
  pleaseenteraccountnumber: "请输入账号",
  makecleaningeasy: "蜗小白·让清洁简单点",
  corporation: "北京智行者科技股份有限公司",
  notauserofthisplatform: "非本平台用户",
  supportphonenamesearch: "支持手机号/姓名搜索",
  batchdelete: "批量删除",
  add: "添加",
  pleaseselct: "请选择",
  domesticusers: "国内用户",
  internationalusers: "国际用户",
  delete: "删除",
  resetpassword: "重置密码",
  tips: "提示",
  areyousure: "是否确定",
  selecteddata: "选中的数据",
  selectphonenumber: "请选择用户手机号",
  savetime: "保存成功",
  pleasetryagain: "保存失败，请重试！",
  successfullydeleted: "删除成功",
  nouserselected: "未选择用户",
  passwordresetto: "密码已重置为",
  agent: "代理商",
  userrole: "用户角色",
  customertype: "用户类型",
  usercomments: "用户备注",
  entermapname: "请输入定时任务名称/地图名称",
  repetitionperiod: "重复周期",
  monday: "周一",
  tuesday: "周二",
  wednesday: "周三",
  thursday: "周四",
  friday: "周五",
  saturday: "周六",
  sunday: "周日",
  forcedendtime: "强制结束时间",
  expectedendtime: "预计结束时间",
  timeconsuming: "耗时",
  basicinformations: "基本资料",
  inputtel: "请输入手机号",
  changepassword: "修改密码",
  originalpassword: "原密码",
  enteroriginalpassword: "请输入原密码",
  newpassword: "新密码",
  enternewpassword: "请输入新密码",
  confirmnewpassword: "确认新密码",
  enternewpasswordagain: "请再次输入新密码",
  successfullymodified: "修改成功",
  modificationfailed: "修改失败",
  passwordissame: "新密码与原密码相同",
  twicenotsame: "两次输入的密码不相同",
  supportvinsearch: "支持VIN搜索",
  onlinevehicles: "在线车辆",
  faultyvehicle: "故障车辆",
  presence: "在线状态",
  faultstatus: "故障状态",
  entrycontrol: "进入控制",
  wakeup: "唤醒",
  awakening: "唤醒中",
  confirmwanttowakevehicle: "是否确认要唤醒车辆？",
  wakeupsuccessfully: "唤醒成功",
  wakeupfailed: "唤醒失败，请重试",
  entryname: "项目名称",
  clearwatervolume: "清水量",
  sewagevolume: "污水量",
  speeded: "速度",
  recentanomalies: "最近异常",
  newuser: "新建用户",
  pleaseentervenueinformation: "请输入场地信息",
  language: "语言",
  selectrole: "请选择角色",
  messageswitch: "消息开关",
  dutyhours: "值班时间",
  remark: "备注",
  incorrectformat: "手机号格式不正确",
  cannotbeempty: "手机号不能为空",
  simplifiedchinese: "简体中文",
  english: "英语",
  german: "德语",
  fillinyournamecorrectly: "请正确填写您的姓名！",
  createdsuccessfully: "创建成功",
  submittedsuccessfully: "提交成功",
  enterphoneusername: "请输入手机号/用户名搜索",
  state: "状态",
  changesuccessful: "更改成功",
  changefailed: "更改失败",
  confirmdisable:
    "请确认禁用,禁用该用户后，TA将无法使用小程序和移动APP，确定要禁用吗？",
  mobilephone: "手机",
  responsibleforthenumberofvehicles: "负责车辆数",
  supportusernamesearch: "支持用户名搜索",
  edit: "编辑",
  deleteconfirmation: "删除确认",
  deletedata: "是否删除选中数据?",
  administrator: "超级管理员",
  admincannotbedeleted: "不可以删除超级管理员",
  lastlogintime: "最后登录时间",
  snaprecorde: "抓拍记录",
  metre: "米",
  changesleeptime: "变更休眠时间",
  schedule: "进度",
  supplymission: "补给任务",
  returndockingpoint: "返回停靠点",
  successfullyset: "设置成功",
  settingfailed: "设置失败",
  sleeptimeerrorhint: "必须是纯数字，且范围必须在900秒到86400秒之间",
  supportvinvehiclenamecustomer: "支持VIN、车辆名称以及场地名称搜索",
  vehicletype: "车辆类型",
  novehicleselected: "未选择车辆",
  switchdisplaymode: "切换展示方式",
  enterworkstationnumber: "输入工作站设备编号",
  newworkstation: "新建工作站",
  enterdevicenumber: "请输入设备编号",
  inputenamehint: "请输入名称",
  manualreset: "手动复位",
  occupy: "占用",
  notavailable: "不可用",
  equipmentnumber: "设备编号",
  workstationname: "工作站名称",
  adaptivevehiclemodel: "适配车型",
  enableornot: "是否启用",
  workingmode: "工作模式",
  delayedrelease: "延迟释放",
  channel: "信道",
  on: "开",
  off: "关",
  vehicles: "车辆",
  totalDevices: "设备总数",
  onlineDevices: "在线设备",
  cleaningArea: "清洁面积",
  operatingCleaningTime: "运行清洁时间",
  operatingCleaningArea: "运行清洁面积",
  days7: "7天",
  days30: "30天",
  days90: "90天",
  tasksuccesscount: "任务成功数",
  taskabnormalcount: "任务异常数",
  taskTotalCount: "任务总数",
  faultstatistics: "故障统计",
  powerconsumption: "用电量",
  cleaningEfficiencyStatistics: "清洁效率统计",
  maxCleaningEfficiency: "最大清洁效率",
  cleaningEfficiency: "清洁效率",
  taskEndNormal: "正常结束",
  taskEndAbnormal: "异常结束",
  taskEndPreparationFail: "准备失败",
  taskEndSupply: "补给",
  taskEndShutdown: "关机",
  taskEndLocalizationFail: "定位失败",
  taskEndRescueTimeout: "救援超时",
  taskEndGlobalPathFail: "全局路径失败",
  taskEndDispatchPathFail: "调度路径失败",
  taskEndNearGoalRescueFail: "接近目标救援失败",
  taskEndLowWaterSkip: "低水位跳过",
  taskEndCrossFloorFail: "跨楼层失败",
  taskEndNodeFault: "节点故障",
  taskEndPedalPressed: "踏板被按下",
  taskEndSewageAbnormal: "污水异常",
  taskEndTargetUnreachable: "目标不可达",
  taskEndStartInVirtualWall: "在虚拟墙中启动",
  taskEndUnknown: "未知",
};
